import { apiFetch, parseErrorDetail } from "@/api/fetch";
import { ExtractionRequestError } from "../api/curation";
import type { Coverage, DatasetBuilderProgress } from "./types";

const jsonRequest = async <T>(path: string, init?: RequestInit): Promise<T> => {
  const response = await apiFetch(path, init);
  if (!response.ok) {
    throw new ExtractionRequestError(await parseErrorDetail(response), response.status);
  }
  return response.json() as Promise<T>;
};

/** The stages of a chat, or of the chat of a dataset. */
export const getDatasetBuilderProgress = async (
  owner: { sessionId: string } | { datasetId: string },
): Promise<DatasetBuilderProgress> => {
  const params = new URLSearchParams(
    "sessionId" in owner ? { session_id: owner.sessionId } : { dataset_id: owner.datasetId },
  );
  const progress = await jsonRequest<Partial<DatasetBuilderProgress>>(
    `/extractions/progress?${params}`,
    { method: "GET" },
  );
  return {
    session_id: progress.session_id ?? null,
    dataset_id: progress.dataset_id ?? null,
    stages: Array.isArray(progress.stages) ? progress.stages : [],
  };
};

/** Reads the coverage of a master list. It does not split or save anything. */
export const getCoverage = (datasetId: string, resultId: string): Promise<Coverage> =>
  jsonRequest(`/extractions/${encodeURIComponent(datasetId)}/coverage`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ result_id: resultId }),
  });
